module.exports = __webpack_public_path__ + "static/img/6.6333eefd.png";